import {GenexLMSModel} from "@/models/lms/GenexLMSModel";
import GenexHelperMixins from "@/mixins/GenexHelperMixins";

export default class LessonBookmarks extends GenexLMSModel {
    static entity = "lesson-bookmarks";

    static fields() {
        return {
            user_id: this.attr(null),
            lesson_id: this.attr(null),
            timeStamp: this.attr(0),
        }
    }

    /**
     * @param {Object} pagination
     * @param {Number} pagination.page page number
     * @param {Number} pagination.limit page limit
     * @param {Object} query query object
     * @returns Promise
     */

    static Fetch({ page = 1, limit = 15 }, query = {}) {
        return this.api().get(`/lesson-bookmarks`, {
            ...GenexHelperMixins.methods.DefaultLMSHeadersAndBaseUrl(),
            params: {
                page: page,
                limit: limit,
                ...(Object.keys(query).length > 0 ? query : {})
            },
            dataTransformer: ({data: {data}}) => {
                return { ...data, ...data.attributes };
            },
        })
    }

    /**
     * @param {Object} bookmark object
     * @returns promise
     */
    static Save(bookmark) {
        return this.api().post(`/lesson-bookmarks`, bookmark, {
            ...GenexHelperMixins.methods.DefaultLMSHeadersAndBaseUrl(),
            dataTransformer: ({data: {data}}) => {
                return { ...data, ...data.attributes };
            },
        })
    }

     /**
     * @param {Object} bookmark object
     * @returns promise
     */
    static Delete(bookmark) {
        return this.api().delete(`/lesson-bookmarks`, bookmark, {
            ...GenexHelperMixins.methods.DefaultLMSHeadersAndBaseUrl(),
            dataTransformer: ({data: {data}}) => {
                return { ...data, ...data.attributes };
            },
        })
    }
}